export default {"src":"/_next/static/media/life-into-dated-yard.e39ba798.svg","height":33,"width":35,"blurWidth":0,"blurHeight":0};